<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content h-100" style="background: white">
      <Home
        v-if="page == 'home'"
        @changePage="changePage"
        @mtdBackRol="mtdBackRol"
      />
      <Especialidades v-if="page == 'especialidad'" @returnHome="returnHome" />
      <Subespecialidad v-if="page == 'subespecialidad'" @returnHome="returnHome" />
      <Categoria v-if="page == 'categoria'" @returnHome="returnHome" />
      <Schedule v-if="page == 'schedule'" @returnHome="returnHome" />
      <Sede v-if="page == 'sede'" @returnHome="returnHome" />
      <Boxes v-if="page == 'boxes'" @returnHome="returnHome" />
      <Marca v-if="page == 'marca'" @returnHome="returnHome" />
      <Medicine v-if="page == 'medicine'" @returnHome="returnHome" />
      <Susalud v-if="page == 'susalud'" @returnHome="returnHome" />
      <VoucherType v-if="page == 'voucherType'" @returnHome="returnHome" />
      <Almacen v-if="page == 'almacen'" @returnHome="returnHome" />
      <Proveedores v-if="page == 'proveedor'" @returnHome="returnHome" />
      <Asistencial v-if="page == 'asistencial'" @returnHome="returnHome" />
      <Subsubcategoria v-if="page == 'subsubcategoria'" @changePage="returnHome"/>
      <Roles v-if="page == 'roles'" @returnHome="returnHome" />
      <Usuarios v-if="page == 'usuarios'" @returnHome="returnHome" />
      <Insurances v-if="page == 'Insurances'" @returnHome="returnHome" />
      <Insumos v-if="page == 'insumos'" @returnHome="returnHome" />
      <SubSector v-if="page == 'subSector'" @returnHome="returnHome" />
      <Soluciones v-if="page == 'soluciones'" @returnHome="returnHome" />
      <Materials v-if="page == 'materials'" @returnHome="returnHome" />
      <Design v-if="page == 'design'" @returnHome="returnHome" />
      <Color v-if="page == 'color'" @returnHome="returnHome" />
      <Add v-if="page == 'add'" @returnHome="returnHome" />
      <Altura v-if="page == 'altura'" @returnHome="returnHome" />
      <MontajeVue v-if="page == 'montaje'" @returnHome="returnHome" />
      <Range v-if="page == 'range'" @returnHome="returnHome" />
      <CentralCosto v-if="page == 'centrales'" @returnHome="returnHome" />
      <Doctor v-if="page == 'doctores'" @returnHome="returnHome" />
      <Bank v-if="page == 'banks'" @returnHome="returnHome" />
    </div>
  </div>
</template>

<script>
import Nav from "../../components/Maintenance/Nav.vue";
import Home from "../../components/Maintenance/Home.vue";
import Especialidades from "../../components/Maintenance/pages/Especialidad.vue";
import Subespecialidad from "../../components/Maintenance/pages/Subespecialidad.vue";
import Categoria from "../../components/Maintenance/pages/Categoria.vue";
import Schedule from "../../components/Maintenance/pages/Schedule.vue";
import Sede from "../../components/Maintenance/pages/Sede.vue";
import Boxes from "../../components/Maintenance/pages/Boxes.vue";
import Marca from '../../components/Maintenance/pages/Brand.vue';
import Medicine from "../../components/Maintenance/pages/Medicine.vue";
import Susalud from "../Maintenance/Susalud/Susalud.vue";
import VoucherType from "../../components/Maintenance/pages/VoucherType.vue";
import Almacen from "../../components/Maintenance/pages/Alma.vue";
import Proveedores from '../../components/Maintenance/pages/Proveedores.vue';
import Asistencial from '../../components/Maintenance/pages/Asistencial.vue';
import Subsubcategoria from "../../components/Logistica/pages/Mantenimiento/Medicine.vue";
import Roles from "@/components/Maintenance/pages/Roles.vue";
import Usuarios from "@/components/Maintenance/pages/Usuarios.vue";
import Insurances from "../../components/Maintenance/pages/Insurances.vue";
import Insumos  from "../../components/Maintenance/pages/Insumos.vue"
import Soluciones from '../../components/Maintenance/pages/Soluciones.vue';
import Materials from '../../components/Maintenance/pages/Materials.vue';
import Design from '../../components/Maintenance/pages/Design.vue'
import Color from '../../components/Maintenance/pages/Color.vue'
import Add from '../../components/Maintenance/pages/Add.vue'
import Altura from '../../components/Maintenance/pages/Altura.vue'
import MontajeVue from '@/components/Maintenance/pages/Montaje.vue';
import Range from '@/components/Maintenance/pages/Range.vue';
import CentralCosto from '@/components/Maintenance/pages/CentralCosto.vue';
import Doctor from '@/components/Maintenance/pages/Medico.vue';
import Bank from '@/components/Maintenance/pages/Banks.vue';
export default {
  name: "v-maintenance",
  components: {
    Nav,
    Home,
    Especialidades,
    Subespecialidad,
    Categoria,
    Schedule,
    Sede,
    Boxes,
    Marca,
    Medicine,
    Susalud,
    VoucherType,
    Almacen,
    Proveedores,
    Asistencial,
    Subsubcategoria,
    Roles,
    Usuarios,
    Insurances,
    Insumos,
    Soluciones,
    Materials,
    Design,
    Color,
    Add,
    Altura,
    MontajeVue,
    Range,
    CentralCosto,
    Doctor,
    Bank
  },

  data() {
    return {
      page: "home",
    };
  },
  props:{
    rolname: String
  },

  methods: {
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdBackRol: function () {
      this.$emit("mtdBackRol");
    },
  },
};
</script>

<style scoped></style>
